/**
 * Check if given input is a valid timestamp.
 *
 * Accepts timestamps as number or string.
 */
export default function isTimeStamp(timestamp) {
  return new Date(Number(timestamp)).getTime() > 0;
}
